export const headlineTemplate = `
    <div class="pl_table-view--headline squirrel_searchSuggestions__headline js_squirrel_ignore_close_suggest squirrel_border_top">
        <span class="pl_copy75 js_squirrel_ignore_close_suggest">BELIEBTE SUCHEN</span>
    </div>
`;

export const keywordsTemplate = `
    {{#keywords}}
    <li class="squirrel_searchSuggest" data-qa-id="search-suggest">
        <div class="pl_table-view__item pl_table-view__item--fully-clickable">
            <div class="squirrel_searchSuggest__text js_squirrel_searchSuggest" 
                 data-qa-id="search-suggest-text">
                    <svg class="pl_icon" role="img"
                         style="flex: 0 0 24px;height:24px;margin-right: 16px"
                    >
                        <use xlink:href="/assets-static/icons/pl_icon_arrow-graph.svg#pl_icon_arrow-graph"></use>
                    </svg>
                    <span data-suggestPos="{{suggestPos}}" data-target="{{target}}" data-term="{{term}}"
                          class="pl_copy100 squirrel_searchSuggest__term js_squirrel_searchSuggest__term">{{{term}}}</span>
                    <div class="squirrel_searchSuggest__right-icon">
                        <svg class="pl_icon" role="img">
                            <use xlink:href="/assets-static/icons/pl_icon_arrow-right.svg#pl_icon_arrow-right"/>
                        </svg>
                    </div>
            </div>
        </div>
    </li>
    {{/keywords}}
`;
